import React from "react";

const ToolsSeparator = () => {
    return <div className="w-px h-8 bg-outline-mild"></div>
}

export default ToolsSeparator
